import React from 'react';

const LigneHorizontal = () => {
    return (
        <div className="ligne-horizontal"></div>
    );
};

export default LigneHorizontal;
